import paymentsServices from '@/api/paymentServices';
import type { RootState } from '@/app/store';
import { RecentPayment } from '@/interfaces/payment';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface PaymentState {
  recentPayments: RecentPayment[];
  selectedPayment: any;
  loading: boolean;
  paymentLoading: boolean;
  error: string;
}

const initialState: PaymentState = {
  recentPayments: [],
  selectedPayment: {},
  loading: false,
  paymentLoading: false,
  error: '',
};

export const fetchRecentPayments = createAsyncThunk('payments/fetch', async (_, thunkAPI) => {
  try {
    const result = await paymentsServices.getRecentPayments();
    return result;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.data);
  }
});

export const fetchPayment = createAsyncThunk('payments/fetchPayment', async ({ id }: { id: string }, thunkAPI) => {
  try {
    const result = await paymentsServices.fetchPayment(id);
    return result;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.data);
  }
});

export const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    refresh: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchRecentPayments.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchRecentPayments.fulfilled, (state, action) => {
      const { payload: data } = action;
      state.recentPayments = data.payments;
      state.loading = false;
    });
    builder.addCase(fetchRecentPayments.rejected, state => {
      state.loading = false;
      state.error = 'Error';
    });

    builder.addCase(fetchPayment.pending, state => {
      state.paymentLoading = true;
    });
    builder.addCase(fetchPayment.fulfilled, (state, action) => {
      const { payload: data } = action;
      state.selectedPayment = data;
      state.paymentLoading = false;
    });
    builder.addCase(fetchPayment.rejected, state => {
      state.paymentLoading = false;
      state.error = 'Error';
    });
  },
});

export const { refresh } = paymentsSlice.actions;

export const selectPayments = (state: RootState) => state.payments;

export default paymentsSlice.reducer;
